import React from 'react';
import './Success.css';

const SuccessPage: React.FC = () => {
    return (
        <div className="success-container">
            <div className="success-content">
                {/* Animated checkmark */}
                <div className="icon-container">
                    <div className="success-icon">&#10003;</div>
                </div>
                <h1>Registration Successful!</h1>
                <p>Your documents have been submitted and are now being verified by our team.</p>

                {/* Estimated timeline */}
                <div className="success-eta">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--blue-500, #4F6EF7)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                    <span>Estimated approval time: <strong>24 – 48 hours</strong></span>
                </div>

                {/* Timeline */}
                <div className="next-steps">
                    <h3>What's Next?</h3>
                    <div className="timeline-step">
                        <div className="timeline-dot green"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg></div>
                        <div className="timeline-info">
                            <h4>Document Verification</h4>
                            <p>Our team reviews your FSSAI, GST, and PAN documents</p>
                        </div>
                    </div>
                    <div className="timeline-step">
                        <div className="timeline-dot blue"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>
                        <div className="timeline-info">
                            <h4>Approval &amp; Onboarding</h4>
                            <p>Once approved, you'll receive login credentials via email &amp; WhatsApp</p>
                        </div>
                    </div>
                    <div className="timeline-step">
                        <div className="timeline-dot cyan"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg></div>
                        <div className="timeline-info">
                            <h4>Go Live</h4>
                            <p>Set up your menu, counters, and start accepting orders!</p>
                        </div>
                    </div>
                </div>

                {/* Action buttons */}
                <div className="success-actions">
                    <a href="/status" className="success-btn primary">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                        Track Application Status
                    </a>
                    <a href="/" className="success-btn secondary">
                        Register Another Location
                    </a>
                </div>

                <p className="success-contact">
                    Questions? Contact us at <a href="mailto:info@aslinformationservices.com">info@aslinformationservices.com</a> or call <strong>+91 70932 81075</strong>
                </p>
            </div>
        </div>
    );
};

export default SuccessPage;
